import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Formik, useFormik, Field, Form } from 'formik'
import CustomError from '../../../../utils/customError'
import Swal from 'sweetalert2'
import { SWAL_SETTINGS, INPUT_MAX_25, PHONE_NO_LENGTH, LOADER_TIMEOUT_TIME, DOCTOR_SPECIALIZATION, SUGAR_TYPE, SLEEP_PATTERN, ROLE, DIET_CHART_MAPPING } from '../../../../utils/Constants'
import { handleServerValidations, DT, globalLoader, getDateWithTime, removeSpecialCharacter, capitalizeFirstLetter, formateDate, handleOffcanvasScroll, calculateAgeFromDob } from '../../../../utils/commonfunction'
import { DatePicker, Drawer } from 'rsuite'
import { createPrescription, detail, dietChartDetails, dietChartHistory, editHealth, historyHealthMatrix, medicalHistoryDocument, sendOTP, uploadMedicalHistoryDocument, verifyOTP } from "../../services/patient.services";
import OtpInput from "react-otp-input";
import { useValidationSchemas } from "../../../center/validator/validation";




export default function PatientView() {
    const { t } = useTranslation()
    const params = useParams();
    const [patientDetail, setPatientDetail] = useState({});
    const [editHealthMatrixSubmissionLoader, setEditHealthMatrixSubmissionLoader] = useState(false);
    const [openWithHeaderHealthMatrixEdit, setOpenWithHeaderHealthMatrixEdit] = useState(false);
    const { editHealthMatrixValidationSchema } = useValidationSchemas();
    const [refreshList, setRefreshList] = useState(false);
    const [openWithHeaderVerifyOTP, setOpenWithHeaderVerifyOTP] = useState(false);
    const { otpValidationSchema } = useValidationSchemas();
    const [medicalHistoryData, setMedicalHistoryData] = useState([]);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [counter, setCounter] = useState(0);
    const navigate = useNavigate();
    const [historyHealthMatrixData, setHistoryHealthMatrixData] = useState([]);
    const [detailsData, setDetailsData] = useState({});
    const [dietChartHistoryData, setDietChartHistoryData] = useState([]);


    useEffect(() => {
        detail({ patient_id: params?.id })
            .then((response) => {
                setPatientDetail(response?.data);
                console.log("response?.data--->", response?.data);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [refreshList]);

    useEffect(() => {
        const formData = new FormData()
        formData.append("patient_id", params?.id)
        dietChartDetails(formData)
            .then((response) => {
                setDetailsData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [])


    useEffect(() => {
        const formData = new FormData()
        formData.append("patient_id", params?.id)
        dietChartHistory(formData)
            .then((response) => {
                setDietChartHistoryData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [])


    const getHealthMatrixData = (id) => {
        let formData = new FormData();
        formData.append("patient_id", id);
        historyHealthMatrix(formData)
            .then((response) => {
                setHistoryHealthMatrixData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getHealthMatrixDetail = (item) => {
        detail({ patient_id: item?._id })
            .then((response) => {
                editHealthMatrixForm.setValues({
                    patient_id: response?.data?._id || "",
                    blood_pressure: response?.data?.health_matrix?.blood_pressure || "",
                    fasting_sugar_level: response?.data?.health_matrix?.fasting_sugar_level || "",
                    postprandial_sugar: response?.data?.health_matrix?.postprandial_sugar || "",
                    hba1c_sugar: response?.data?.health_matrix?.hba1c_sugar || "",
                    sugar_type: response?.data?.health_matrix?.sugar_type || "",
                    pulse_rate: response?.data?.health_matrix?.pulse_rate || "",
                    spo2: response?.data?.health_matrix?.spo2 || "",
                    temperature: response?.data?.health_matrix?.temperature || "",
                    sleep_pattern: response?.data?.health_matrix?.sleep_pattern || "",
                    height: response?.data?.health_matrix?.height || "",
                    weight: response?.data?.health_matrix?.weight || "",
                    digestion: response?.data?.health_matrix?.digestion || "",
                    urine_frequency: response?.data?.health_matrix?.urine_frequency || "",
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const editHealthMatrixForm = useFormik({
        initialValues: {
            patient_id: "",
            blood_pressure: "",
            fasting_sugar_level: "",
            postprandial_sugar: "",
            hba1c_sugar: "",
            sugar_type: "",
            pulse_rate: "",
            spo2: "",
            temperature: "",
            sleep_pattern: "",
            height: "",
            weight: "",
            digestion: "",
            urine_frequency: ""
        },
        validationSchema: editHealthMatrixValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            setEditHealthMatrixSubmissionLoader(true);
            const formData = new FormData();
            formData.append("patient_id", patientDetail._id);
            formData.append("blood_pressure", values.blood_pressure);
            formData.append("fasting_sugar_level", values.fasting_sugar_level);
            formData.append("postprandial_sugar", values.postprandial_sugar);
            formData.append("hba1c_sugar", values.hba1c_sugar);
            formData.append("sugar_type", values.sugar_type);
            formData.append("pulse_rate", values.pulse_rate);
            formData.append("height", values.height);
            formData.append("weight", values.weight);
            formData.append("spo2", values.spo2);
            formData.append("temperature", values.temperature);
            formData.append("sleep_pattern", values.sleep_pattern);
            formData.append("digestion", values.digestion);
            formData.append("urine_frequency", values.urine_frequency);
            editHealth(formData)
                .then((response) => {
                    setEditHealthMatrixSubmissionLoader(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm();
                        setOpenWithHeaderHealthMatrixEdit(false);
                        setRefreshList(!refreshList);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setEditHealthMatrixSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });


    const handleResend = async () => {
        globalLoader(true);
        setResendDisabled(true);
        setCounter(30);
        let formData = new FormData();
        formData.append("o_id", patientDetail?._id);
        sendOTP(formData)
            .then((response) => {
                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                    globalLoader(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                    globalLoader(false);
                }
            })
            .catch((error) => {
                console.log("error: ", error);
            });
    };

    const handleSendOTP = async (item) => {
        let formData = new FormData();
        formData.append("o_id", item._id);
        sendOTP(formData)
            .then((response) => {
                if (response.success) {
                    //no otp authentication required
                    if(!response.data.otp_authentication_required){
                        const patientHistoryList = response?.data?.patient_history_list;
                        navigate(`/doctor/patient/medical-history/view`, { state: { medical_data: patientHistoryList, info: patientDetail } })
                    }else{
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        setOpenWithHeaderVerifyOTP(true);
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                }
            })
            .catch((error) => {
                console.log("error: ", error);
            });
    };

    const handleSubmit = async (values) => {
        const otpValue = values.otp;
        try {
            await otpValidationSchema.validate(values, { abortEarly: false });
            let formData = new FormData();
            formData.append("patient_id", patientDetail?._id);
            formData.append("otp", otpValue);
            verifyOTP(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        setMedicalHistoryData(response?.data);
                        setOpenWithHeaderVerifyOTP(false);
                        navigate(`/doctor/patient/medical-history/view`, { state: { medical_data: response?.data, info: patientDetail } })
                        // const modalElement = document.getElementById("view-medical-history");
                        // if (modalElement) {
                        //     modalElement.classList.add("show");
                        // }
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    console.log("error: ", error);
                });
        } catch (error) {
            console.log(error)
        }
    };

    const formatValueWithUnit = (value, unit) => (value ? `${value} ${unit}` : "-");


    return (
        <main id="main-content" className="mt-4">
            <div className='ms-3 me-3'>
                <div className="row">
                    <div className="col-md-12">
                        {/* Personal Info Section */}
                        <div className="card p-4 mb-4 card-info">
                            <h3>Personal Info</h3>
                            <p className="mb-1">#{patientDetail?.patient_register_id}</p>
                            <h4 className="mb-1">{capitalizeFirstLetter(patientDetail?.name)}</h4>
                            <div className='mb-3 d-flex gap-2 align-items-center'>
                                <p className='m-0'>{capitalizeFirstLetter(patientDetail?.gender)}</p>
                                <p className='m-0'>I</p>
                                <p className='m-0'>{patientDetail?.phone_number}</p>
                            </div>
                            <div className='table-div-info'>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>Email</p>
                                    </div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{(patientDetail?.email)}</p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>DOB</p>
                                    </div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{formateDate(patientDetail?.dob)}</p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>Language Preference</p>
                                    </div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{capitalizeFirstLetter(patientDetail?.language_preference)}</p>
                                    </div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>Location</p>
                                    </div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>{capitalizeFirstLetter(patientDetail?.address)}</p>
                                    </div>
                                </div>
                                <div className='card-info-action'>
                                    <button className="btn btn-primary mt-2"
                                        onClick={() => {
                                            getHealthMatrixData(patientDetail?._id);
                                        }}
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#view-diet-chart"
                                    >View Diet Chart
                                    </button>
                                    <button className="btn btn-warning mt-2 ms-2"
                                        onClick={() => {
                                            getHealthMatrixData(patientDetail?._id);
                                        }}
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#view-diet-chart-history"
                                    >View Diet Chart History
                                    </button>
                                    <button className="btn btn-secondary mt-2 ms-2"
                                        onClick={() => {
                                            navigate(`/doctor/settings/patient/1`)
                                        }}>
                                        Back
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Health Matrix Section */}
                        <div className="card p-4 mb-4 card-info">
                            <h3>Health Matrix</h3>

                            <div className='table-div-info'>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Height</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.height, "cm.")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Weight</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.weight, "Kg")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Age</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(calculateAgeFromDob(patientDetail?.dob), "Years")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Blood Pressure</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.blood_pressure, "mm/hg")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Pulse Rate</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.pulse_rate, "BPM")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Fasting Level Sugar</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.fasting_sugar_level, "mg/dl")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Postprandial Sugar</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.postprandial_sugar, "mg/dl")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>HbA1c Sugar</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.hba1c_sugar, "%")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>SpO2 Level</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.spo2, "%")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Temperature</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{formatValueWithUnit(patientDetail?.health_matrix?.temperature, "°F")}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Sleep Pattern</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {patientDetail?.health_matrix?.sleep_pattern ?
                                                capitalizeFirstLetter(removeSpecialCharacter(patientDetail?.health_matrix?.sleep_pattern)) : "-"}
                                        </p>
                                    </div>
                                </div>
                                {/* <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Sugar Type</p></div>
                                    <div className='table-div-info-item'>
                                        <p className='m-0'>
                                            {patientDetail?.health_matrix?.sugar_type ?
                                                capitalizeFirstLetter(removeSpecialCharacter(patientDetail?.health_matrix?.sugar_type)) : "-"}
                                        </p>
                                    </div>
                                </div> */}
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Digestion</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{capitalizeFirstLetter(patientDetail?.health_matrix?.digestion) ?? "-"}</p></div>
                                </div>
                                <div className='table-div-info-row'>
                                    <div className='table-div-info-item'><p className='m-0'>Urine Frequency</p></div>
                                    <div className='table-div-info-item'><p className='m-0'>{patientDetail?.health_matrix?.urine_frequency ?? "-"}</p></div>
                                </div>
                            </div>
                            <div className='card-info-action'>
                                <button className="btn btn-primary mt-2"
                                    onClick={() => {
                                        getHealthMatrixDetail(patientDetail);
                                        setOpenWithHeaderHealthMatrixEdit(true);
                                    }}>
                                    Update
                                </button>
                                <button className="btn btn-secondary mt-2 ms-2"
                                    onClick={() => {
                                        getHealthMatrixData(patientDetail?._id);
                                    }}
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#view-health_matrix"
                                >View
                                </button>
                            </div>
                        </div>
                        {/* Medical History Section */}
                        <div className="card p-4 card-info">
                            <h3>Medical History</h3>
                            <p>"Click on the 'View' button to access patient's medical history after verifying the OTP."</p>
                            <div className='card-info-action'>
                                <button className="btn btn-primary mt-2"
                                    onClick={() => {
                                        handleSendOTP(patientDetail);
                                    }}>View</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Drawer open={openWithHeaderHealthMatrixEdit}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">{t("Edit Health Matrix")}</h3>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeaderHealthMatrixEdit(false);
                                editHealthMatrixForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editHealthMatrixForm.handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Blood Pressure(mm/hg)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter blood pressure")}
                                name="blood_pressure"
                                value={editHealthMatrixForm?.values?.blood_pressure}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="blood_pressure" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        {/* <div className="mb-3">
                            <label className="form-label">{t("Select Sugar Type")}
                                <span>*</span>
                                </label>
                            <select className="form-control cp" name='sugar_type' value={editHealthMatrixForm?.values?.sugar_type} onChange={editHealthMatrixForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {SUGAR_TYPE.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                            </select>
                            {editHealthMatrixForm.touched.sugar_type && editHealthMatrixForm.errors.sugar_type ? (
                                <div className="text-danger">{t(editHealthMatrixForm.errors.sugar_type)}</div>
                            ) : null}
                        </div> */}
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Weight(Kg)")}
                                <span>*</span>
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter weight")}
                                name="weight"
                                value={editHealthMatrixForm?.values?.weight}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="weight" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Pulse Rate(BPM)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter value")}
                                name="pulse_rate"
                                value={editHealthMatrixForm?.values?.pulse_rate}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="pulse_rate" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Fasting Sugar Level(mg/dl)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter value")}
                                name="fasting_sugar_level"
                                value={editHealthMatrixForm?.values?.fasting_sugar_level}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="fasting_sugar_level" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Postprandial Sugar(mg/dl)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter value")}
                                name="postprandial_sugar"
                                value={editHealthMatrixForm?.values?.postprandial_sugar}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="postprandial_sugar" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("HbA1c Sugar(%)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter value")}
                                name="hba1c_sugar"
                                value={editHealthMatrixForm?.values?.hba1c_sugar}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="hba1c_sugar" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("SPO2 (%)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter spo2 level")}
                                name="spo2"
                                value={editHealthMatrixForm?.values?.spo2}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="spo2" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Temperature(°F)")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter temperature")}
                                name="temperature"
                                value={editHealthMatrixForm?.values?.temperature}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="temperature" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("Select Sleep Pattern")}
                                {/* <span>*</span> */}
                                </label>
                            <select className="form-control cp" name='sleep_pattern' value={editHealthMatrixForm?.values?.sleep_pattern} onChange={editHealthMatrixForm.handleChange}>
                                <option value={""}>{t("Select")}</option>
                                {SLEEP_PATTERN.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                            </select>
                            {editHealthMatrixForm.touched.sleep_pattern && editHealthMatrixForm.errors.sleep_pattern ? (
                                <div className="text-danger">{t(editHealthMatrixForm.errors.sleep_pattern)}</div>
                            ) : null}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Height(cm.)")}
                                <span>*</span>
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter height")}
                                name="height"
                                value={editHealthMatrixForm?.values?.height}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="height" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Digestion")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter digestion")}
                                name="digestion"
                                value={editHealthMatrixForm?.values?.digestion}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="digestion" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">
                                {t("Urine Frequency")}
                                {/* <span>*</span> */}
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Enter urine frequency")}
                                name="urine_frequency"
                                value={editHealthMatrixForm?.values?.urine_frequency}
                                onChange={editHealthMatrixForm.handleChange}
                                onBlur={editHealthMatrixForm.handleBlur}
                            />
                            <CustomError name="urine_frequency" form={editHealthMatrixForm} className="text-danger" />
                        </div>
                        {/* Submit Button */}
                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editHealthMatrixSubmissionLoader ? " btn-loader" : "")}>
                                Update
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <Drawer open={openWithHeaderVerifyOTP} onClose={() => setOpenWithHeaderVerifyOTP(false)}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h3 className="mb-0">View Medical History</h3>
                        <button
                            className="btn-icon"
                            onClick={() => setOpenWithHeaderVerifyOTP(false)}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>

                <Drawer.Body>
                    <div className="">
                        <h3 className="mt-2 ms-0">{t("center.otp_verification.heading")}</h3>
                    </div>
                    <Formik
                        initialValues={{ otp: "" }}
                        validationSchema={otpValidationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ setFieldValue, errors, touched }) => (
                            <Form>
                                {/* OTP Input Section */}
                                <div className="d-flex w-100 justify-content-between">
                                    <div className="col-md-3 number-otp-section">
                                        <Field name="otp">
                                            {({ field }) => (
                                                <OtpInput
                                                    {...field}
                                                    inputType="number"
                                                    onChange={(value) => setFieldValue("otp", value)}
                                                    numInputs={4}
                                                    separator={<span>-</span>}
                                                    renderInput={(props, index) => (
                                                        <input
                                                            {...props}
                                                            key={index}
                                                            className="form-control"
                                                            style={{
                                                                width: "6rem",
                                                                marginRight: "10px",
                                                                textAlign: "center",
                                                                fontWeight: 600,
                                                            }}
                                                            maxLength="1"
                                                            autoFocus={index === 0}
                                                            placeholder="-"
                                                        />
                                                    )}
                                                />
                                            )}
                                        </Field>
                                        {errors.otp && touched.otp && (
                                            <div className="text-danger mt-1" style={{ display: "ruby-text" }}>{errors.otp}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="button-form mt-3">
                                    <button type="submit" className="btn btn-primary w-100">
                                        Continue
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <div className="login-cta-bottom mt-3">
                        <p style={{ textAlign: "center" }}>
                            {t("center.otp_verification.otp_not_receive")}{" "}
                            <a
                                className={`${resendDisabled ? " disabled" : ""}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (!resendDisabled) {
                                        handleResend();
                                    }
                                }}
                                href="/"
                            >
                                {t("center.otp_verification.btn_resend")}
                            </a>
                            {resendDisabled && <span className="text-secondary ms-2">({counter})</span>}
                        </p>
                    </div>
                </Drawer.Body>
            </Drawer>


            {/* Health Matrix Details */}
            <div className="offcanvas offcanvas-end" id="view-health_matrix" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog"
                style={{
                    width: "60vw", maxHeight: "90vh", overflowY: "auto", position: "fixed", bottom: "0", left: "50%", transform: "translateX(-50%)",
                    zIndex: "1050", top: "50px"
                }}
            >
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Health Matrix Details
                    </h3>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="table-light">
                                <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("Blood Pressure")}</th>
                                    <th>{t("Postprandial Sugar")}</th>
                                    <th>{t("Fasting Level Sugar")}</th>
                                    <th>{t("HbA1c Sugar")}</th>
                                    {/* <th>{t("Sugar Type")}</th> */}
                                    <th>Pulse Rate</th>
                                    <th>Height</th>
                                    <th>Age</th>
                                    <th>SpO2 Level</th>
                                    <th>Temperature</th>
                                    <th>Sleep Pattern</th>
                                    <th>Weight</th>
                                    <th>Digestion</th>
                                    <th>Urine Frequency</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historyHealthMatrixData && historyHealthMatrixData.length > 0 ? (
                                    historyHealthMatrixData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formateDate(item.createdAt)}</td>
                                            <td>{item.health_matrix.blood_pressure ? `${item.health_matrix.blood_pressure} mm/hg` : '-'}</td>
                                            <td>{item.health_matrix.postprandial_sugar ? `${item.health_matrix.postprandial_sugar} mg/dL` : '-'}</td>
                                            <td>{item.health_matrix.fasting_sugar_level ? `${item.health_matrix.fasting_sugar_level} mg/dL` : '-'}</td>
                                            <td>{item.health_matrix.hba1c_sugar ? `${item.health_matrix.hba1c_sugar} %` : '-'}</td>
                                            {/* <td>{item.health_matrix.sugar_type ? capitalizeFirstLetter(removeSpecialCharacter(item.health_matrix.sugar_type)) : '-'}</td> */}
                                            <td>{item.health_matrix.pulse_rate ? `${item.health_matrix.pulse_rate} bpm` : '-'}</td>
                                            <td>{item.health_matrix.height ? `${item.health_matrix.height} cm` : '-'}</td>
                                            <td>{patientDetail?.dob ? `${calculateAgeFromDob(patientDetail?.dob)} years` : '-'}</td>
                                            <td>{item.health_matrix.spo2 ? `${item.health_matrix.spo2} %` : '-'}</td>
                                            <td>{item.health_matrix.temperature ? `${item.health_matrix.temperature} °F` : '-'}</td>
                                            <td>{item.health_matrix.sleep_pattern ? capitalizeFirstLetter(removeSpecialCharacter(item.health_matrix.sleep_pattern)) : '-'}</td>
                                            <td>{item.health_matrix.weight ? `${item.health_matrix.weight} kg` : '-'}</td>
                                            <td>{item.health_matrix.digestion ? capitalizeFirstLetter(item.health_matrix.digestion) : '-'}</td>
                                            <td>{item.health_matrix.urine_frequency ? `${item.health_matrix.urine_frequency} times/day` : '-'}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: 'center' }}>No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* View Diet Chart */}
            <div
                className="offcanvas offcanvas-end"
                id="view-diet-chart"
                data-bs-backdrop="static"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-modal="true"
                role="dialog"
                style={{
                    width: "60vw",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    position: "fixed",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: "1050",
                    top: "50px"
                }}
            >
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Diet Chart
                    </h3>
                    <button
                        type="button"
                        className="btn btn-icon ms-auto"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    >
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="accordion" id="dietChartAccordion">
                        {detailsData?.diet_chart_details?.diet_chart?.length > 0 ? (
                            detailsData.diet_chart_details?.diet_chart?.map((dayItem, index) => (
                                <div className="accordion-item mb-3" key={index}>
                                    <h2 className="accordion-header" id={`heading-${index}`}>
                                        <button
                                            className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse-${index}`}
                                            aria-expanded={index === 0 ? "true" : "false"}
                                            aria-controls={`collapse-${index}`}
                                        >
                                            {dayItem.day}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse-${index}`}
                                        className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                        aria-labelledby={`heading-${index}`}
                                        data-bs-parent="#dietChartAccordion"
                                    >
                                        <div className="accordion-body">
                                            {Object.entries(dayItem.meals).map(([mealName, mealValue], i) => (
                                                <div key={i} className="mb-3">
                                                    <strong>{DIET_CHART_MAPPING[mealName] || mealName}:</strong>
                                                    <div className="ms-3">
                                                        {
                                                            mealValue?.food?.map((food, index) => {
                                                                if(index)return <div><em>{`OR ${food}`}</em></div>
                                                                return <div><em>{food}</em></div>
                                                            })
                                                        }
                                                        <div className="text-muted small">
                                                            Quantity: 
                                                            {
                                                               Array.isArray(mealValue.quantity)
                                                                ? mealValue.quantity?.map((quantity, index) => (
                                                                    index 
                                                                    ? <div><em key={index}>{`OR ${quantity}`}</em></div> 
                                                                    : <div><em key={index}>{quantity}</em></div>
                                                                ))
                                                                : <em>{mealValue.quantity}</em>  
                                                            }
                                                        </div>
                                                        <div className="text-muted small">
                                                            Calories: {mealValue?.macros?.calories} kcal,&nbsp;
                                                            Protein: {mealValue?.macros?.protein}g,&nbsp;
                                                            Fat: {mealValue?.macros?.fat}g,&nbsp;
                                                            Carbs: {mealValue?.macros?.carbs}g,&nbsp;
                                                            Fiber: {mealValue?.macros?.fiber}g
                                                        </div>
                                                        <div className="text-muted small">Benefits: <em>{mealValue?.ayurvedic_benefits}</em></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="alert alert-info text-center">No Diet Chart Data Found</div>
                        )}
                    </div>

                    <h3>Your daily calorie requirement is : {detailsData?.tdee}</h3>
                </div>
            </div>


            {/* View Diet Chart History */}
            <div
                className="offcanvas offcanvas-end"
                id="view-diet-chart-history"
                data-bs-backdrop="static"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-modal="true"
                role="dialog"
                style={{
                    width: "60vw",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    position: "fixed",
                    bottom: "0",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: "1050",
                    top: "50px",
                }}
            >
                <div className="offcanvas-header">
                    <h3 className="offcanvas-title" id="offcanvasRightLabel">
                        View Diet Chart History
                    </h3>
                    <button
                        type="button"
                        className="btn btn-icon ms-auto"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    >
                        <i className="ti ti-x"></i>
                    </button>
                </div>

                <div className="offcanvas-body">
                    {dietChartHistoryData?.length > 0 ? (
                        <div className="accordion" id="historyAccordion">
                            {dietChartHistoryData.map((history, historyIndex) => (
                                <>
                                    <div className="accordion-item mb-4" key={historyIndex}>
                                        <h2 className="accordion-header" id={`history-heading-${historyIndex}`}>
                                            <button
                                                className={`accordion-button ${historyIndex !== 0 ? "collapsed" : ""}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#history-collapse-${historyIndex}`}
                                                aria-expanded={historyIndex === 0 ? "true" : "false"}
                                                aria-controls={`history-collapse-${historyIndex}`}
                                            >
                                                Diet Chart - {formateDate(history.createdAt)}
                                            </button>
                                        </h2>

                                        <div
                                            id={`history-collapse-${historyIndex}`}
                                            className={`accordion-collapse collapse ${historyIndex === 0 ? "show" : ""}`}
                                            aria-labelledby={`history-heading-${historyIndex}`}
                                            data-bs-parent="#historyAccordion"
                                        >
                                            <div className="accordion-body">
                                                <div className="accordion" id={`innerAccordion-${historyIndex}`}>
                                                    {history?.diet_chart_details?.diet_chart?.map((dayItem, dayIndex) => (
                                                        <div className="accordion-item mb-2" key={dayIndex}>
                                                            <h2 className="accordion-header" id={`day-heading-${historyIndex}-${dayIndex}`}>
                                                                <button
                                                                    className={`accordion-button ${dayIndex !== 0 ? "collapsed" : ""}`}
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#day-collapse-${historyIndex}-${dayIndex}`}
                                                                    aria-expanded={dayIndex === 0 ? "true" : "false"}
                                                                    aria-controls={`day-collapse-${historyIndex}-${dayIndex}`}
                                                                >
                                                                    {dayItem.day}
                                                                </button>
                                                            </h2>

                                                            <div
                                                                id={`day-collapse-${historyIndex}-${dayIndex}`}
                                                                className={`accordion-collapse collapse ${dayIndex === 0 ? "show" : ""}`}
                                                                aria-labelledby={`day-heading-${historyIndex}-${dayIndex}`}
                                                                data-bs-parent={`#innerAccordion-${historyIndex}`}
                                                            >
                                                                <div className="accordion-body">
                                                                    {Object.entries(dayItem.meals).map(([mealName, mealValue], i) => (
                                                                        <div key={i} className="mb-3">
                                                                            <strong>{DIET_CHART_MAPPING[mealName] || mealName}:</strong>
                                                                            <div className="ms-3">
                                                                                {/* <div><em>{mealValue.food}</em></div> */}
                                                                                {
                                                                                    Array.isArray(mealValue.food) && mealValue?.food?.map(food => <div><em>{food}</em></div>)
                                                                                }
                                                                                <div className="text-muted small">Quantity: <em>{mealValue.quantity}</em></div>
                                                                                <div className="text-muted small">
                                                                                    Calories: {mealValue.macros?.calories ?? 0} kcal,&nbsp;
                                                                                    Protein: {mealValue.macros?.protein ?? 0}g,&nbsp;
                                                                                    Fat: {mealValue.macros?.fat ?? 0}g,&nbsp;
                                                                                    Carbs: {mealValue.macros?.carbs ?? 0}g,&nbsp;
                                                                                    Fiber: {mealValue.macros?.fiber ?? 0}g
                                                                                </div>
                                                                                <div className="text-muted small">Ayurvedic Benefits: <em>{mealValue?.ayurvedic_benefits}</em></div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <h3>Your daily calorie requirement is : {history?.tdee}</h3>
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>
                    ) : (
                        <div className="alert alert-info text-center">No Diet Chart History Found</div>
                    )}
                </div>
            </div>

        </main>
    )
}
